/**
 * How far a chunked read has got, counted in the unit the reader chunks by
 * (EANs, keys, rows). Numbers only: the label a user reads is a presentation
 * concern the consumer adds, so the data layer never carries a UI string.
 */
export type ChunkProgress = {
  readonly loaded: number;
  readonly total: number;
};

/** Passed into a repository read that wants to report how far it has got. */
export type ChunkProgressReporter = (progress: ChunkProgress) => void;

/**
 * Reports one step of a chunked read.
 *
 * Clamps `loaded` to `total` because readers count a whole wave at a time and
 * the last wave is usually short, and stays silent on an empty read so a
 * caller cannot be handed a 0/0 to divide by.
 */
export function reportChunkProgress(
  report: ChunkProgressReporter | undefined,
  loaded: number,
  total: number
): void {
  if (!report || total <= 0) return;
  report({ loaded: Math.min(loaded, total), total });
}
